module.exports = __webpack_public_path__ + "8941801c422ad0f39101b478941f8e8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-420.jpg
// module id = 363
// module chunks = 0